export const DUE_DATE_TOOLTIP =
  'La fecha de vencimiento es el último día que tienes para pagar la factura sin empezar a generar intereses por mora.';
